export const addAnalyticsArticleClick = (title, url) => {
  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction: `my account:favorites:all:${title}`,
    eventName: `my account:favorites:all:${title}`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: title,
    internalLinkPosition: "favorites",
    internalLinkType: "my account:navigation",
    internalLinkURL: url,
    clickInternalLinks: "true",
    internalLinkZoneName: "my account:favorites:all",
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const addAnalyticsVideoClick = (videoTitle, videoUrl, videoId) => {
  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction: "my account:favorites:video play",
    eventName: "my account:favorites:video play",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "video play",
    internalLinkPosition: "favorites",
    internalLinkType: "my account:navigation",
    internalLinkURL: videoUrl,
    clickInternalLinks: "true",
    internalLinkZoneName: "my account:favorites:videos",
    videoName: videoTitle,
    videoId: videoId,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}
export const addAnalyticsVideoClose = (videoTitle, videoUrl, videoId) => {
  const { adobeDataLayer: {} = {} } = window

  const eventInfo = {
    eventAction: `my account:favorites:${videoTitle}:close`,
    eventName: `my account:favorites:${videoTitle}:close`,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "close",
    internalLinkPosition: "favorites",
    internalLinkType: "my account:navigation",
    internalLinkURL: videoUrl,
    clickInternalLinks: "true",
    internalLinkZoneName: "my account:favorites:videos",
    videoName: videoTitle,
    videoId: videoId,
  }
  pushAnalyticsObjToDataLayer(eventInfo)
}

const pushAnalyticsObjToDataLayer = (eventInfo = {}) => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  const event = "cmp:click"
  window.adobeDataLayer.push({
    event,
    eventInfo,
    page,
  })
}
